'use client'

import React from 'react'
import CategoriesSlider from '../CategoriesSlider'
import { megaschoolInfoItem } from '@/assets/data/megaschool'
import MegaInfoCard from './MegaInfoCard'
import { useGetAllMegaschoolReleasesQuery } from '@/redux/services/megaschoolReleasesApi'
import { useTranslation } from 'react-i18next'

interface Props {
    type: string
    propsdata?: any
    staticpropsdata?: any
    sendManager?: any
}

const Megaschool: React.FC<Props> = ({ type, propsdata, staticpropsdata, sendManager }) => {
    const { data } = useGetAllMegaschoolReleasesQuery()
    const { t } = useTranslation()

    const data_static = {
        tag: t('data_static_tag'),
        title: t('Megaschool'),
        text: t('megaschool_card_content'),
        btnText: t('watch_on_Youtube'),
        btnTextOrange: t('Megakorm_website')
    }

    return (
        data && (
            <div
                className='megaschool'
                id='megaschool'
            >
                {staticpropsdata ? (
                    <MegaInfoCard
                        type={type}
                        item={staticpropsdata}
                        sendManager={sendManager ? sendManager : undefined}
                    />
                ) : (
                    <MegaInfoCard
                        type={type}
                        item={data_static}
                    />
                )}
                <div className='megaschool__cards-wrapper'>
                    {propsdata ? (
                        <CategoriesSlider
                            page='media'
                            list={propsdata}
                            type={type}
                        />
                    ) : (
                        <CategoriesSlider
                            page='media'
                            list={data.filter(el => {
                                return el?.enableToView === true
                            })}
                        />
                    )}
                </div>
            </div>
        )
    )
}

export default Megaschool
